import { render, staticRenderFns } from "./AnnouncementsSingle.vue?vue&type=template&id=5fe244ef"
import script from "./AnnouncementsSingle.vue?vue&type=script&lang=js"
export * from "./AnnouncementsSingle.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementsSingle.vue?vue&type=style&index=0&id=5fe244ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports